/**
 * Where a console opened on another name for its firm should be instead.
 *
 * A firm answers on the addresses stored for it, and — by the old convention underneath —
 * on `<company code>.<domain>` as well. Both used to be live consoles: two sites, two
 * sessions, two sets of saved preferences, and an administrator signed in on one in one tab
 * and the other in the next without being able to tell which was the firm's (#374). So a
 * console that finds itself on a name its firm does not list moves to the first name it
 * does, keeping the path, the query and the fragment — an old invitation link or bookmark
 * still lands where it meant to, on the one site.
 *
 * Only on a standard port. The console's dev server runs on `:5174`, on `localhost` or on a
 * firm's name, and must stay where it is; so must anything reached by a bare address.
 *
 * Pure, and its own file, so a test can reach it without a browser.
 */

export interface Here {
  protocol: string;
  hostname: string;
  port: string;
  pathname: string;
  search: string;
  hash: string;
}

export function addressToMoveTo(here: Here, addresses: readonly string[] | null | undefined): string | null {
  const own = (addresses ?? []).map((address) => address.toLowerCase());
  const first = own[0];

  if (first === undefined || here.port !== '') return null;

  const host = here.hostname.toLowerCase();

  if (own.includes(host) || host === 'localhost' || /^[\d.]+$/.test(host) || host.includes(':')) {
    return null;
  }

  return `${here.protocol}//${first}${here.pathname}${here.search}${here.hash}`;
}
